import { useState } from 'react';

export default function SupplySelectionSection() {
  const [activeItem, setActiveItem] = useState('selection');

  const navItems = [
    { id: 'selection', label: '智能选品', icon: 'ri-search-line' },
    { id: 'rules', label: '选品规则', icon: 'ri-settings-3-line' },
    { id: 'analysis', label: '数据分析', icon: 'ri-bar-chart-line' }
  ];

  return (
    <section className="py-16 lg:py-24 bg-white">
      <div className="container mx-auto px-12 lg:px-16 xl:px-24">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
            {/* 左侧文字介绍 */}
            <div className="lg:order-2">
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
                供给选品
              </h2>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                智能选品引擎，精准匹配商品，提升营销转化率
              </p>
              
              {/* 导航菜单 */}
              <div className="mb-8">
                {navItems.map((item) => (
                  <div
                    key={item.id}
                    onClick={() => setActiveItem(item.id)}
                    className={`relative flex items-center px-4 py-3 mb-2 rounded-lg cursor-pointer transition-colors ${
                      activeItem === item.id
                        ? 'bg-blue-50 text-blue-700'
                        : 'text-gray-600 hover:bg-gray-100'
                    }`}
                  >
                    {activeItem === item.id && (
                      <div className="absolute left-0 top-0 bottom-0 w-1 bg-blue-600 rounded-r"></div>
                    )}
                    <i className={`${item.icon} mr-3 text-lg`}></i>
                    <span className="font-medium">{item.label}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* 右侧图片 */}
            <div className="lg:order-1 flex items-center justify-center">
              <img 
                src="/2.png" 
                alt="供给选品" 
                className="w-full h-auto rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

